import { SerializedStyles, css } from '@emotion/react';

import styled from '@emotion/styled';

import { withConfig } from 'src/withConfig';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';



export const MainContent = withConfig(theme => styled('div', { label: 'MainContent' })`

    padding-left: 16px;

    @media ${theme.star.mediaQuery.desktop} {

        padding-left: 24px;

    }

`);



export const HamburgerMenuFaker = styled('div', { label: 'HamburgerMenuFaker' })`

    margin-right: 16px;

`;



export const ContentWrapper = withConfig(theme => styled('div', { label: 'ContentWrapper' })`

    display: flex;

    flex: 1 1 0%;

    flex-flow: column nowrap;

    width: 100%;

    

    @media ${theme.star.mediaQuery.largeDesktop} {

        flex-direction: row;

    }

`);



interface ContentWrapperChildrenPropsType {

    streamRmgWrapperIsVisible: boolean | undefined;

    isStreamOpen: boolean | undefined;

    isAccountOpen: boolean | undefined;

    variant: DefaultComponentVariantType | null;

}



const setStreamVisibleWhenIsFloating = (theme: EmotionTheme, streamRmgWrapperIsVisible: boolean | undefined, isStreamOpen: boolean | undefined, isAccountOpen: boolean | undefined): SerializedStyles => {

    if (isAccountOpen === true) {

        return css`

            z-index: ${theme.star.zIndexGlobal.base};

        `;

    };



    if (streamRmgWrapperIsVisible === false && isStreamOpen === true && isAccountOpen === false) {

        return css`

            overflow: initial;

            z-index: ${theme.star.zIndexGlobal.floatingStream};

        `;

    };



    return css``;

};



export const ContentWrapperChildren = withConfig(theme => styled('div', { label: 'ContentWrapperChildren' })<ContentWrapperChildrenPropsType>`

    overflow: hidden;

    flex: 1 1 0%;

    display: flex;

    flex-flow: column nowrap;

    gap: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.gap.medium : '0'};

    @media ${theme.star.mediaQuery.largeDesktop} {

        flex: 1 1 auto;

        width: calc(100% - 200px);

        ${({ streamRmgWrapperIsVisible, isStreamOpen, isAccountOpen }): SerializedStyles => setStreamVisibleWhenIsFloating(theme, streamRmgWrapperIsVisible, isStreamOpen, isAccountOpen)};

    }

`);



export const HeaderMainLogoWrapper = styled('div', { label: 'HeaderMainLogoWrapper' })`

    width: 56px;

    height: auto;

    display: flex;

    flex: auto;

`;